export type Role = 'SuperAdmin' | 'TenantAdmin' | 'TenantMember'

export const isTenantAdmin = (role: Role | undefined) =>
  role === 'TenantAdmin' || role === 'SuperAdmin'

export const isSuperAdmin = (role: Role | undefined) =>
  role === 'SuperAdmin'